import { Component,  OnDestroy, OnInit, PLATFORM_ID, Inject, ChangeDetectorRef, Optional, input } from '@angular/core';
import { KreuzfahrtFilters } from '../../../../models/filtermodels/KreuzfahrtFilters';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatDialog } from '@angular/material/dialog';
import { CruiseFiltersService } from '@app/services/cruis/cruisefilters.service';
import { isPlatformBrowser } from '@angular/common';
import moment from 'moment';
import { CruiseService } from '@app/services/cruise.service';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { Partner } from '@app/models/partner/IPartner';
import { CruiseRegion } from '@app/models/kreuzfahrts/CruiseRegion';
import { CruiseCompany } from '@app/models/kreuzfahrts/CruiseCompany';
import { Schiffe } from '@app/models/kreuzfahrts/Schiffe';
import { MEDIA_TOKEN } from '../../../../../../tockens';
import { cruisereiseDauer } from '@app/components/tools/CruiseStatic';
import { Router } from '@angular/router';
interface Item1 {
    land?: string;
    name: string;
    code: string;
    id: string;
    selected: boolean;
}
@Component({
    selector: 'app-cruisefilter',
    templateUrl: './cruisefilter.component.html',
    styleUrls: ['./cruisefilter.component.scss'],
    standalone: false
})
export class CruisefilterComponent implements OnInit, OnDestroy {
    readonly mode = input<string>(undefined);
    readonly realparams = input<KreuzfahrtFilters>(undefined);
    readonly reference = input<string>(undefined);
    protected unsubscribe$ = new Subject();
    myKrzfilters: KreuzfahrtFilters = {} as KreuzfahrtFilters;
    media: string = 'xl';

    isBrowser: boolean = false;
    showMore: boolean = false;
    smallVersion: boolean = true;
    btntext: string = 'Kreuzfahrt finden';
    start: string;
    end: string;
    currentpartner: Partner;
    cruiseregions: CruiseRegion[] = [];
    cruiseCompany: CruiseCompany[] = [];
    cruiseCompanypriority: CruiseCompany[] = [];
    cruiseschiffe: Schiffe[] = [];
    private filtersLoaded = false;

    airports: Item1[] = [];
    startHafenDatas: Item1[] = [];
    ziehlHafenDatas: Item1[] = [];
    reiseDauer: any
    selectedReisedauer: any;
    activeTab: 'kreuzfahrten' | 'mitflug' = 'kreuzfahrten';
    selectedTab: 'kreuzfahrten' | 'mitflug' = 'kreuzfahrten';

    constructor(
        protected dialog: MatDialog,
        protected cruiseService: CruiseService,
        protected mediaObserver: BreakpointObserver,
        protected cdr: ChangeDetectorRef,
        protected cruiseFiltersService: CruiseFiltersService,
        protected guardService: AuthGuardService,
        private router: Router,
        @Inject(PLATFORM_ID) protected platformId: any,
        @Optional() @Inject(MEDIA_TOKEN) private media_token: string
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
        this.media = this.media_token;
    }

    ngOnInit(): void {
        this.initMedia();
        this.initPartner();
        this.getCruiseShips();
        this.reiseDauer = JSON.parse(JSON.stringify(cruisereiseDauer));
        if (this.isBrowser) {
            this.setFilters();
        }
    }

    setFilters(): void {
        const realparams = this.realparams();
        if (realparams) {
            realparams.productType = 'kreuzfahrt';
            this.cruiseFiltersService.onlySetRealParams(realparams);
        } else if (this.mode() === 'home') {
            this.cruiseFiltersService.resetAllExtrasHome();
        }
    }

    async initPartner() {
        this.guardService.getPartner$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((partner) => {
            if (partner?.partnerid?.length > 0) {
                this.currentpartner = partner;
                this.getFilters();
            }
        });
    }

    async getPorts() {
        this.cruiseService.request({ ref: this.currentpartner?.xt?.ref }, 'cruiseregionsdsi').pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe(res => {
            this.initPorts(res);
        });
    }

    async getAirPorts() {
        this.cruiseService.request({ ref: this.currentpartner?.xt?.ref }, 'cruiseairports').pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe(res => {
            this.initAirports(res);
        });
    }

    async initMedia() {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.media = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.media = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.media = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.media = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.media = 'xl';
        }
        this.cdr.detectChanges();
    }

    selectTab(tab: 'kreuzfahrten' | 'mitflug') {
        this.selectedTab = tab;
        const type = tab === 'mitflug' ? 'S' : 'NS';
        this.cruiseFiltersService.cruisesuchetype(type, false);
        this.cdr.detectChanges();
    }

    getClipPath(tab: 'kreuzfahrten' | 'mitflug') {
        const isSelected = this.selectedTab === tab;

        if (isSelected) {
            // ✅ Selected: both sides slant inward (like ◤▭◥)
            return {
                'clip-path': 'polygon(8px 0, calc(100% - 8px) 0, 100% 100%, 0 100%)'
            };
        }

        // Inactive shapes depending on which one is selected
        if (tab === 'kreuzfahrten' && this.selectedTab === 'mitflug') {
            // Left (inactive): slant only right side inward
            return {
                'clip-path': 'polygon(8px 0, calc(100% - 8px) 0, 100% 100%, 0 100%)'
            };
        }

        if (tab === 'mitflug' && this.selectedTab === 'kreuzfahrten') {
            // Right (inactive): slant only left side inward
            return {
                'clip-path': 'polygon(8px 0, calc(100% - 8px) 0, 100% 100%, 0 100%)'
            };
        }

        // Default (not expected, just fallback)
        return {
            'clip-path': 'polygon(8px 0, calc(100% - 8px) 0, 100% 100%, 0 100%)'
        };
    }

    async getCruiseRegionen() {
        this.cruiseService
            .request({ ref: this.currentpartner?.xt?.ref }, 'cruiseregions')
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((data) => {
                if (data?.length > 0) {
                    // Preserve preselected items
                    if (this.myKrzfilters?.cruiseregion?.length > 0) {
                        for (let i = 0; i < data.length; i++) {
                            for (let j = 0; j < this.myKrzfilters.cruiseregion.length; j++) {
                                if (data[i].id === this.myKrzfilters.cruiseregion[j].id) {
                                    data[i].selected = true;
                                }
                            }
                        }
                    }

                    // Remove duplicates (your existing helper)
                    let cleaned = this.cleanDoublon(data);

                    // ✅ Sort alphabetically (locale-aware, case-insensitive)
                    cleaned = cleaned
                        .filter(r => r.name && r.name.trim() !== '') // avoid empty entries
                        .sort((a, b) =>
                            a.name.localeCompare(b.name, 'de', { sensitivity: 'base' })
                        );

                    this.cruiseregions = cleaned;
                    this.cdr.detectChanges();
                }
            });
    }


    cleanDoublon(data): any[] {
        for (let i = 0; i < data.length; i++) {
            for (let j = i + 1; j < data.length; j++) {
                if (data[i].id === data[j].id) {
                    data.splice(j, 1);
                    j--;
                }
            }
        }

        return data;
    }
    setTab(tab: 'kreuzfahrten' | 'mitflug') {
        this.activeTab = tab;
        const type = tab === 'mitflug' ? 'S' : 'NS';
        this.cruiseFiltersService.cruisesuchetype(type, true);
    }


    async cruisedurationresult(ev: any) {
        this.selectedReisedauer = ev?.id ?? null;

        // Update filter service
        this.cruiseFiltersService.cruiseduration(this.selectedReisedauer, this.mode() !== 'home');


        // Update local filter state
        this.myKrzfilters.cruisedauer = this.selectedReisedauer;

        // Update selection state for UI
        this.reiseDauer = this.reiseDauer.map(item => ({
            ...item,
            selected: item.id === this.selectedReisedauer
        }));
    }

    async getCruiseCompany() {
        this.cruiseService.request({ ref: this.currentpartner?.xt?.ref }, 'cruisecompanys').pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((data) => {
            if (data?.length > 0) {
                data = data.map(c => ({
                    ...c,
                    name: c.name === 'TUI Cruises' ? 'Mein Schiff – TUI Cruises' : c.name
                }));
                if (this.myKrzfilters?.cruisecompanys?.length > 0) {
                    for (let i = 0; i < data.length; i++) {
                        for (let j = 0; j < this.myKrzfilters.cruisecompanys.length; j++) {
                            if (data[i].id === this.myKrzfilters.cruisecompanys[j].id) {
                                data[i].selected = true;
                            }
                        }
                    }
                }
                this.cruiseCompany = this.cleanDoublon(data);
                this.cruiseCompanypriority = [];
                for (let i = 0; i < this.cruiseCompany.length; i++) {
                    if (
                        this.cruiseCompany[i].vc === 'AIDA' ||
                        this.cruiseCompany[i].vc === 'TUIC' ||
                        this.cruiseCompany[i].vc === 'AQVH' ||
                        this.cruiseCompany[i].vc === 'CARN' ||
                        this.cruiseCompany[i].vc === 'CEL' ||
                        this.cruiseCompany[i].vc === 'CELES' ||
                        this.cruiseCompany[i].vc === 'COLOR' ||
                        this.cruiseCompany[i].vc === 'CST' ||
                        this.cruiseCompany[i].vc === 'CUNARD' ||
                        this.cruiseCompany[i].vc === 'EMERALD' ||
                        this.cruiseCompany[i].vc === 'EXPLORA' ||
                        this.cruiseCompany[i].vc === 'HANSA' ||
                        this.cruiseCompany[i].vc === 'HLKF' ||
                        this.cruiseCompany[i].vc === 'HAL' ||
                        this.cruiseCompany[i].vc === 'MSC' ||
                        this.cruiseCompany[i].vc === 'NICH' ||
                        this.cruiseCompany[i].vc === 'NCL' ||
                        this.cruiseCompany[i].vc === 'OCE' ||
                        this.cruiseCompany[i].vc === 'POC' ||
                        this.cruiseCompany[i].vc === 'PHX' ||
                        this.cruiseCompany[i].vc === 'PLAN' ||
                        this.cruiseCompany[i].vc === 'PONANT' ||
                        this.cruiseCompany[i].vc === 'PC' ||
                        this.cruiseCompany[i].vc === 'RSS' ||
                        this.cruiseCompany[i].vc === 'RCCL' ||
                        this.cruiseCompany[i].vc === 'ROW' ||
                        this.cruiseCompany[i].vc === 'RVS' ||
                        this.cruiseCompany[i].vc === 'SCENIC' ||
                        this.cruiseCompany[i].vc === 'SEAB' ||
                        this.cruiseCompany[i].vc === 'SEAC' ||
                        this.cruiseCompany[i].vc === 'SEAD' ||
                        this.cruiseCompany[i].vc === 'SILV' ||
                        this.cruiseCompany[i].vc === 'STARCL' ||
                        this.cruiseCompany[i].vc === 'SWAN' ||
                        this.cruiseCompany[i].vc === 'TRDW' ||
                        this.cruiseCompany[i].vc === 'AZA'
                    ) {
                        this.cruiseCompanypriority.push(this.cruiseCompany[i]);
                    }
                }
                this.cruiseCompanypriority = this.cruiseCompanypriority.sort((a, b) => a.name.localeCompare(b.name))
                this.cdr.detectChanges();
            }
        });
    }

    async getCruiseSchifes() {
        this.cruiseService.request({ ref: this.currentpartner?.xt?.ref }, 'cruiseschiffe').pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((data) => {
            if (data?.length > 0) {
                if (this.myKrzfilters?.schiffes?.length > 0) {
                    for (let i = 0; i < data.length; i++) {
                        for (let j = 0; j < this.myKrzfilters.schiffes.length; j++) {
                            if (data[i].id === this.myKrzfilters.schiffes[j].id) {
                                data[i].selected = true;
                            }
                        }
                    }
                }
                this.cruiseschiffe = this.cleanDoublon(data);
                this.cdr.detectChanges();
            }
        });
    }

    async initAirports(res) {
        if (res?.length > 0) {
            for (let i = 0; i < res.length; i++) {
                let selected = false;
                if (this.myKrzfilters?.airports?.length > 0) {
                    for (let j = 0; j < this.myKrzfilters.airports.length; j++) {
                        if (res[i].code === this.myKrzfilters.airports[j].code) {
                            selected = true;
                            j = this.myKrzfilters.airports.length;
                        }
                    }
                }
                this.airports.push({
                    id: res[i].code,
                    code: res[i].code,
                    name: res[i].name,
                    land: res[i].land,
                    selected: selected
                });
            }
            this.cdr.detectChanges();
            this.airports = JSON.parse(JSON.stringify(this.airports));
        }
    }

    async initPorts(res) {
        if (res?.length > 0) {
            const startHafenDatas: Item1[] = [];
            const ziehlHafenDatas: Item1[] = [];

            for (let i = 0; i < res.length; i++) {
                let selectedStart = false;
                if (this.myKrzfilters?.cruisestarthafen?.length > 0) {
                    for (let j = 0; j < this.myKrzfilters.cruisestarthafen.length; j++) {
                        if (res[i].code === this.myKrzfilters.cruisestarthafen[j].code) {
                            selectedStart = true;
                            break;
                        }
                    }
                }

                startHafenDatas.push({
                    id: res[i].code,
                    code: res[i].code,
                    name: res[i].name,
                    land: res[i].land,
                    selected: selectedStart
                });

                let selectedZiel = false;
                if (this.myKrzfilters?.cruisezielhafen?.length > 0) {
                    for (let j = 0; j < this.myKrzfilters.cruisezielhafen.length; j++) {
                        if (res[i].code === this.myKrzfilters.cruisezielhafen[j].code) {
                            selectedZiel = true;
                            break;
                        }
                    }
                }

                ziehlHafenDatas.push({
                    id: res[i].code,
                    code: res[i].code,
                    land: res[i].land,
                    name: res[i].name,
                    selected: selectedZiel
                });
            }

            // ✅ Sort alphabetically by name (case-insensitive)
            // ✅ Sort safely even if some ports have no name
            this.startHafenDatas = startHafenDatas.sort((a, b) => {
                const nameA = (a.name || '').toLowerCase();
                const nameB = (b.name || '').toLowerCase();
                return nameA.localeCompare(nameB, 'de', { sensitivity: 'base' });
            });

            this.ziehlHafenDatas = ziehlHafenDatas.sort((a, b) => {
                const nameA = (a.name || '').toLowerCase();
                const nameB = (b.name || '').toLowerCase();
                return nameA.localeCompare(nameB, 'de', { sensitivity: 'base' });
            });


            this.cdr.detectChanges();

            // // Optional: deep copy if you still want it (not necessary for sorting)
            // this.startHafenDatas = JSON.parse(JSON.stringify(this.startHafenDatas));
            // this.ziehlHafenDatas = JSON.parse(JSON.stringify(this.ziehlHafenDatas));
        }
    }


    async getFilters() {
        this.cruiseFiltersService.getfilters$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(params => {
                if (!params) return;

                // 🧠 Prevent re-triggering on the same update
                if (this.filtersLoaded) return;
                this.filtersLoaded = true;

                this.myKrzfilters = JSON.parse(JSON.stringify(params));
                this.initDate(this.myKrzfilters);

                // ✅ Set tab safely (without infinite emit loops)
                // const cruiseType = this.myKrzfilters?.cruisesuchetype;
                // console.log('cruiseType:', cruiseType);

                // Use a small timeout so change detection stabilizes before re-render
                // if (cruiseType === 'S') {
                //     setTimeout(() => this.setTab('mitflug'), 0);
                // } else {
                //     setTimeout(() => this.setTab('kreuzfahrten'), 0);
                // }

                // ✅ Load data only once
                if (!this.startHafenDatas?.length) this.getPorts();
                if (!this.airports?.length) this.getAirPorts();
                if (!this.cruiseregions?.length) this.getCruiseRegionen();
                if (!this.cruiseCompany?.length) this.getCruiseCompany();
                if (!this.cruiseschiffe?.length) this.getCruiseSchifes();
            });
    }


    async checkSchifes() {
        if (this.myKrzfilters?.schiffes?.length > 0) {
            for (let i = 0; i < this.cruiseschiffe.length; i++) {
                let selected = false;
                for (let j = 0; j < this.myKrzfilters.schiffes.length; j++) {
                    if (this.cruiseschiffe[i].id === this.myKrzfilters.schiffes[j].id) {
                        selected = true;
                        j = this.myKrzfilters.schiffes.length;
                    }
                }
                this.cruiseschiffe[i].selected = selected;
            }
        } else {
            for (let i = 0; i < this.cruiseschiffe.length; i++) {
                this.cruiseschiffe[i].selected = false;
            }
        }

        this.cruiseschiffe = JSON.parse(JSON.stringify(this.cruiseschiffe));
    }

    async checkCompany() {
        if (this.myKrzfilters?.cruisecompanys?.length > 0) {
            for (let i = 0; i < this.cruiseCompany.length; i++) {
                let selected = false;
                for (let j = 0; j < this.myKrzfilters.cruisecompanys.length; j++) {
                    if (this.cruiseCompany[i].id === this.myKrzfilters.cruisecompanys[j].id) {
                        selected = true;
                        j = this.myKrzfilters.cruisecompanys.length;
                    }
                }
                this.cruiseCompany[i].selected = selected;
            }
        } else {
            for (let i = 0; i < this.cruiseCompany.length; i++) {
                this.cruiseCompany[i].selected = false;
            }
        }

        this.cruiseCompany = JSON.parse(JSON.stringify(this.cruiseCompany));
    }

    async checkRegion() {
        if (this.myKrzfilters?.cruiseregion?.length > 0) {
            for (let i = 0; i < this.cruiseregions.length; i++) {
                let selected = false;
                for (let j = 0; j < this.myKrzfilters.cruiseregion.length; j++) {
                    if (this.cruiseregions[i].id === this.myKrzfilters.cruiseregion[j].id) {
                        selected = true;
                        j = this.myKrzfilters.cruiseregion.length;
                    }
                }
                this.cruiseregions[i].selected = selected;
            }
        } else {
            for (let i = 0; i < this.cruiseregions.length; i++) {
                this.cruiseregions[i].selected = false;
            }
        }

        this.cruiseregions = JSON.parse(JSON.stringify(this.cruiseregions));
    }

    async checkAirports() {
        if (this.myKrzfilters?.airports?.length > 0) {
            for (let i = 0; i < this.airports.length; i++) {
                let selected = false;
                for (let j = 0; j < this.myKrzfilters.airports.length; j++) {
                    if (this.airports[i].id === this.myKrzfilters.airports[j].id || this.airports[i].code === this.myKrzfilters.airports[j].code) {
                        selected = true;
                        j = this.myKrzfilters.airports.length;
                    }
                }
                this.airports[i].selected = selected;
            }
        } else {
            for (let i = 0; i < this.airports.length; i++) {
                this.airports[i].selected = false;
            }
        }

        this.airports = JSON.parse(JSON.stringify(this.airports));
    }

    async getCruiseShips() {
        this.cruiseService.request(
            { ref: this.currentpartner?.xt?.ref },
            'cruisecompanyships'
        ).pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((data) => {
            if (data?.length > 0) {
                // Apply preselection from filters if any
                if (this.myKrzfilters?.schiffes?.length > 0) {
                    for (let i = 0; i < data.length; i++) {
                        for (let j = 0; j < this.myKrzfilters.schiffes.length; j++) {
                            if (data[i].id === this.myKrzfilters.schiffes[j].id) {
                                data[i].selected = true;
                            }
                        }
                    }
                }

                this.cruiseschiffe = this.cleanDoublon(data);
                this.cdr.detectChanges();
            }
        });
    }


    async checkPort() {
        if (this.myKrzfilters?.cruisestarthafen?.length > 0) {
            for (let i = 0; i < this.startHafenDatas.length; i++) {
                let selected = false;
                for (let j = 0; j < this.myKrzfilters.cruisestarthafen.length; j++) {
                    if (this.startHafenDatas[i].id === this.myKrzfilters.cruisestarthafen[j].id || this.startHafenDatas[i].code === this.myKrzfilters.cruisestarthafen[j].code) {
                        selected = true;
                        j = this.myKrzfilters.cruisestarthafen.length;
                    }
                }
                this.startHafenDatas[i].selected = selected;
            }
        } else {
            for (let i = 0; i < this.startHafenDatas.length; i++) {
                this.startHafenDatas[i].selected = false;
            }
        }
        // zielhafen
        if (this.myKrzfilters?.cruisezielhafen?.length > 0) {
            for (let i = 0; i < this.ziehlHafenDatas.length; i++) {
                let selected = false;
                for (let j = 0; j < this.myKrzfilters.cruisezielhafen.length; j++) {
                    if (this.ziehlHafenDatas[i].id === this.myKrzfilters.cruisezielhafen[j].id || this.ziehlHafenDatas[i].code === this.myKrzfilters.cruisezielhafen[j].code) {
                        selected = true;
                        j = this.myKrzfilters.cruisezielhafen.length;
                    }
                }
                this.ziehlHafenDatas[i].selected = selected;
            }
        } else {
            for (let i = 0; i < this.ziehlHafenDatas.length; i++) {
                this.ziehlHafenDatas[i].selected = false;
            }
        }

        this.startHafenDatas = JSON.parse(JSON.stringify(this.startHafenDatas));
        this.ziehlHafenDatas = JSON.parse(JSON.stringify(this.ziehlHafenDatas));
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    async gotoZiel(): Promise<void> {
        this.smallVersion = true;
        this.cruiseFiltersService.setReference(this.reference());
        await this.cruiseFiltersService.gotourl();
        if (this.router.url.includes('cruise/?params')) {
            window.location.reload();
        }
    }

    initDate(filter): void {
        const reg = new RegExp('^\\d+,\\d+,\\d+$');
        if (String(filter?.reisezeitraumResult).match(reg)) {
            const tmp = String(filter?.reisezeitraumResult).split(',');
            this.start = moment().add(tmp[0], 'days').format('YYYY-MM-DD');
            this.end = moment().add(Number(tmp[1]) + Number(tmp[0]), 'days').format('YYYY-MM-DD');
        } else if (filter?.reisezeitraumResult?.start?.length > 0) {
            if (moment(filter.reisezeitraumResult.start).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')) {
                this.start = moment().add(4, 'days').format('DD.MM.YYYY');
                this.end = moment().add(180, 'days').format('DD.MM.YYYY');
            } else {
                this.start = moment(filter.reisezeitraumResult.start).format('YYYY-MM-DD');
                this.end = moment(filter.reisezeitraumResult.end).format('YYYY-MM-DD');
            }
        } else if (!isNaN(Number(filter.reisezeitraumResult?.start))) {
            this.start = moment().add(Number(filter.reisezeitraumResult.start), 'days').format('YYYY-MM-DD');
            this.end = moment().add(Number(filter.reisezeitraumResult.end), 'days').format('YYYY-MM-DD');
        } else {
            this.start = moment().add(4, 'days').format('YYYY-MM-DD');
            this.end = moment().add(180, 'days').format('YYYY-MM-DD');
        }
    }

    selectDateValue(ev): void {
        this.cruiseFiltersService.reisezeitraumResult(ev.start, ev.end);
    }

    openclosemore(): void {
        this.showMore = !this.showMore;
        if (!this.showMore) {
            // window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    async resTraveler(ev) {
        this.cruiseFiltersService.reisendeResult(ev);
    }


    setRes(filed, ev) {
        this.myKrzfilters[filed] = ev;
        switch (filed) {
            case 'cruiseregion':
                this.cruiseFiltersService.cruiseregion(ev);
                break;
            case 'cruisecompanys':
                this.cruiseFiltersService.cruisecompanys(ev);
                break;
            case 'cruisestarthafen':
                this.cruiseFiltersService.cruisestarthafen(ev);
                break;
            case 'cruisezielhafen':
                this.cruiseFiltersService.cruisezielhafen(ev);
                break;
            case 'airports':
                this.cruiseFiltersService.airports(ev);
                break;

            default:
                this.cruiseFiltersService.schiffes(ev, this.mode() !== 'home');
                break;
        }
    }

    showMBMenu(): void {
        this.smallVersion = false;
    }
}
